import React from 'react';
import { Container } from '../../UI/Container/Container';
import { PrismicHTMLParser } from '../../PrismicHTMLParser';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import './TextBlock.scss';

type TextBlockProps = {
    slice: {
        slice_type: 'text_block';
        primary: {
            text_block_content: {
                html: string | null;
            };
        };
    };
};

const TextBlock = ({ slice }: TextBlockProps) => (
    <Container size="md">
        <Grid className="Text-block">
            <GridRow horizontalAlign={'h-start'} verticalAlign={'v-center'} className="Bloc-row">
                <GridCol colSize={`10`} offsetSize={`0`} mobileColSize={'12'}>
                    <PrismicHTMLParser>{slice.primary.text_block_content.html}</PrismicHTMLParser>
                </GridCol>
            </GridRow>
        </Grid>
    </Container>
);

export { TextBlock, TextBlockProps };
